import React, {useState} from 'react';
import {Button, FormFieldLabel, Table, Textarea} from '../../../ui';
import { useAppSelector } from "../../../redux/hooks";
import { selectCustomer } from "../../../redux/slices/customer-slice";
import './style.css';
import {IComment} from "../../../models/comments-data.interface";
import { formatter } from '../../../utils/time-utils';
import AddCommentView from "../../base/add-comment-view";
import { Modal } from '../../../ui';

export default function CommentsDataView() {
  const customer = useAppSelector(selectCustomer());
  const [isIsAddCommentModalOpen, setIsAddCommentModalOpen] = useState(false);

  const handleAddCommentClick = () => {
    setIsAddCommentModalOpen(true);
  };

  function renderCommentItem(comment: IComment) {
    return (
      <Table.Tr key={comment.id} className='table-row'>
        <Table.Td className='col1'>{comment.summary}</Table.Td>
        <Table.Td className='col2'>
          <Textarea
            className='comments-textarea'
            value={comment.description}
            readOnly={true}
            disabled={true}

          />
        </Table.Td>
        <Table.Td className='col3'>{comment.creatorType + ' (' + comment.creator + ')'}</Table.Td>
        <Table.Td className='col4'>{formatter.format(new Date(comment.updatedAt))}</Table.Td>
      </Table.Tr>
    );
  }

  return (
    <>
      <div className='comments-details' data-testid="commentDataTableComponent">
        <>

            <p className='label comment-header'>
              <div>
                Comments for customer
              </div>
              <div className='comment-header-right'>
                <Button
                  className='blue-button'
                  data-testid='unmarkForDeletionButtonTestID'
                  onClick={handleAddCommentClick}
                  disabled={false}
                  title='Add Comment for this customer.'
                >Add Comment
                </Button>
              </div>
            </p>
        </>
        {customer.customer?.comments && customer.customer?.comments?.length > 0 && (
          <div>
            <Table colored={true} className='comments-table'>
              <Table.Thead>
                <Table.Tr >
                  <Table.Th>Summary</Table.Th>
                  <Table.Th>Description</Table.Th>
                  <Table.Th>Created By</Table.Th>
                  <Table.Th>Timestamp</Table.Th>
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>{customer.customer?.comments?.map((comment) => renderCommentItem(comment))}</Table.Tbody>
            </Table>
          </div>
        )}

        {(!customer.customer?.comments || customer.customer?.comments?.length === 0) && (<FormFieldLabel testId="noConsentDataLabel">No Comment Data</FormFieldLabel>)}

      </div>

      <Modal className='add-comment-modal' title="Add Comment" shown={isIsAddCommentModalOpen} onClose={() => setIsAddCommentModalOpen(false)}>
        <AddCommentView afterSubmit={() => setIsAddCommentModalOpen(false)} />
      </Modal>
    </>
  );
}
